// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2RHSd","title":"BackImages_title__23e9j","images":"BackImages_images__1MBJJ"};